"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _keycode = _interopRequireDefault(require("keycode"));
var _reactDeviceDetect = require("react-device-detect");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      padding: 8,
      cursor: 'pointer'
    },
    rootMobile: {
      backgroundColor: theme.palette.background2
    },
    underline: {
      '&:before': {
        backgroundColor: theme.palette.input.bottomLine,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.ease
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: theme.palette.input.bottomLine,
        height: 2
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: "linear-gradient(to right, ".concat(theme.palette.input.bottomLine, " 33%, transparent 0%)"),
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px'
      }
    },
    inkbar: {
      '&:not($disabled)': {
        '&:not($error):after': {
          backgroundColor: theme.palette.primary.main,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          height: 1,
          position: 'absolute',
          right: 0,
          transform: 'scaleX(0)',
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
          }),
          pointerEvents: 'none' // Transparent to the hover style.
        },
        '&:hover:after': {
          transform: 'scaleX(1)'
        },
        '&$focused:after': {
          transform: 'scaleX(1)'
        },
        '&$error': {
          border: "1px solid ".concat(theme.palette.error.main),
          borderRadius: 2
        }
      }
    },
    disabled: {
      color: theme.palette.text.disabled,
      '&:before': {
        display: 'none'
      }
    },
    focused: {
      backgroundColor: theme.palette.background3
    },
    error: {},
    label: (0, _objectSpread2.default)({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }, theme.typography.body2, {
      display: 'inline-block',
      width: '100%'
    }),
    placeholder: {
      color: '#bdbdbd'
    },
    icon: {
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      })
    },
    iconOpen: {
      transform: 'rotate(90deg)',
      color: theme.palette.primary.main
    },
    iconClose: {
      transform: 'rotate(0deg)'
    }
  };
};

/**
 * @ignore - internal component.
 */
var _ref = /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null);
var HiSelectInput = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelectInput() {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelectInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HiSelectInput, [].concat(args));
    _this.handleKeyDown = function (event) {
      var key = (0, _keycode.default)(event);
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      } else if (key === 'enter' && _this.props.onSubmit) {
        event.preventDefault();
        _this.props.onSubmit(event);
      }
    };
    _this.handleKeyDownReset = function (event) {
      var key = (0, _keycode.default)(event);
      if (key === 'enter' || key === 'space') {
        _this.handleReset(event);
        event.stopPropagation();
        event.preventDefault();
      }
    };
    _this.handleClick = function (event) {
      // Do not open select if press on resetIcon
      if ((!_this.resetIcon || !_this.resetIcon.contains(event.target)) && _this.props.onClick) {
        // Do not open select if press enter on button => submit form
        if (event.type !== 'keydown' || (0, _keycode.default)(event) !== 'enter') {
          _this.props.onClick(event);
        }
      }
    };
    _this.handleReset = function (event) {
      _this.props.onReset(event);
      if (_this.input) {
        _this.input.focus();
      }
    };
    _this.handleBlur = function (event) {
      if ((!_this.input || !_this.input.contains(event.relatedTarget)) && _this.props.onBlur) {
        _this.props.onBlur(event);
      } /* else if (this.input && (!this.resetIcon || !this.resetIcon.contains(event.relatedTarget))) {
          this.input.focus();
        }*/
    };
    _this.ref = function (el) {
      _this.input = el;
      if (_this.props.refElement) {
        _this.props.refElement(el);
      }
    };
    return _this;
  }
  (0, _inherits2.default)(HiSelectInput, _React$PureComponent);
  return (0, _createClass2.default)(HiSelectInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        noButton = _this$props.noButton,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        onReset = _this$props.onReset,
        value = _this$props.value,
        open = _this$props.open,
        focused = _this$props.focused,
        error = _this$props.error,
        id = _this$props.id,
        placeholder = _this$props.placeholder; // On utilise classNames pour variabiliser les styles et merge les classes appliquées
      var rootClass = (0, _classnames.default)(classes.root, classes.inkbar, classes.underline, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.disabled, disabled), classes.focused, focused), classes.error, error && !focused), classes.rootMobile, _reactDeviceDetect.isMobile));
      var iconClass = (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.iconOpen, open), classes.iconClose, !open));
      return noButton ? /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: rootClass,
        onClick: onClick,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onKeyDown: this.handleKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        role: "button",
        tabIndex: "0",
        ref: this.ref
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.placeholder, value === undefined))
      }, value || placeholder), /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, {
        className: iconClass
      })) : /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
        component: "div",
        id: id,
        className: rootClass,
        onClick: this.handleClick,
        disabled: disabled,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onKeyDown: this.handleKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.handleBlur,
        ref: this.ref
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.placeholder, value === undefined))
      }, value || placeholder), onReset && focused && /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(el) {
          _this2.resetIcon = el;
        }
      }, /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
        icon: "close",
        size: 20,
        color: "neutral",
        onClick: this.handleReset,
        onKeyDown: this.handleKeyDownReset,
        tabIndex: 0
      })), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        classes: {
          root: iconClass
        }
      }, _ref));
    }
  }]);
}(_react.default.PureComponent);
HiSelectInput.defaultProps = {
  disabled: false,
  open: false,
  focused: false,
  noButton: false,
  error: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSelectInput'
})(HiSelectInput);